import { Helmet } from 'react-helmet-async';

const MetaTags = ({ 
  title, 
  description, 
  ogTitle, 
  ogDescription, 
  twitterTitle, 
  twitterDescription 
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:image" content="https://teople.co.in/images/MainLogo.webp" />
      <meta property="og:site_name" content="Teople Technologies" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://teople.co.in/images/MainLogo.webp" />
    </Helmet>
  );
};

export default MetaTags;